/**
 * Плитка под фирменным знаком технологии (ТЗ 0070).
 *
 * 🔴 Правило живёт ЗДЕСЬ, а не рядом с холстом карты, потому что применяется в
 * двух местах: в HTML-значке (`SkillIcon`) и в SVG-знаке холста (`SkillGlyph`).
 * Пока копий было две, один и тот же навык мог получить в списке и на карте
 * разные плитки — то есть выглядеть двумя разными.
 *
 * Цвет плитки выбирается по цвету самого знака, а не по теме. Фирменные цвета —
 * данные Simple Icons, и среди них есть оба края: JavaScript #F7DF1E на белом
 * даёт 1.35:1 при норме 3:1 для графики, Django #092E20 на тёмном — 1.16:1.
 * Плитка светлая под тёмным знаком и тёмная под светлым, поэтому знак виден и в
 * светлой теме, и в тёмной, и поверх любой статусной заливки.
 */

/** Обе литеральные: плитка не зависит от темы, см. пояснение выше. */
export const PLATE_LIGHT = '#FFFFFF';
export const PLATE_DARK = '#16191F';

const luminance = (hex: string): number => {
  const channel = (i: number): number => {
    const value = parseInt(hex.slice(1 + i * 2, 3 + i * 2), 16) / 255;
    return value <= 0.03928 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * channel(0) + 0.7152 * channel(1) + 0.0722 * channel(2);
};

export const contrast = (a: string, b: string): number => {
  const [x, y] = [luminance(a) + 0.05, luminance(b) + 0.05];
  return Math.max(x, y) / Math.min(x, y);
};

/**
 * Плитка под знаком: та из двух, на которой знак виден лучше. Норма WCAG для
 * нетекстовой графики — 3:1; светлый выбор её не тянет ровно у четырёх знаков
 * (javascript, clickhouse, swagger, linux), и они получают тёмную плитку.
 */
export const plateFor = (color: string): string =>
  contrast(color, PLATE_LIGHT) >= 3 ? PLATE_LIGHT : PLATE_DARK;
